import { useEffect, useState } from 'react';
import Navbar from '../navbar/navbar'
import { api } from '../../services/api';
import { Link } from 'react-router-dom';
import { vhostV1, vhostV2 } from '../funcoes';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import Loading from '../components/loading/Loading';
import SweetAlert from 'react-bootstrap-sweetalert';
import SRI_pagination from '../components/pagination/pagination';
import WidgetCompra from '../components/widget/widgetCompra';
import customizeScrollbar from "customsb";
import FooterBar from '../footer/footerBar';




function Compra(){

    const [sResult,setSresult] = useState(0);
    const [load,setLoad] = useState(false);
    const [confirmaEmissao,setConfirmaEmissao] = useState(false);
    const [msgErro,setmsgErro] = useState('');
    const [erroEmissao,setErroEmissao] = useState(false);
    const [nPag, setnPag] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [pedidos, setPedidos] = useState([]);
    const [tpRelatorio,setTipoRelatorio] = useState(0);
    const [tipo,setTipo] = useState('TODOS');
    const [dataInical,setDataInicial] = useState(new Date); 
    const [dataFinal,setDataFinal] = useState(new Date);
    const [confirmaDelete,setConfirmaDelete] = useState(false);
    const [confirmaExcluir,setConfirmaExcluir] = useState(false);
    const [codDelete,setCodDelete] = useState(0);

    const [dCadastro1,setDcadastro1] = useState(new Date);
    const [dAlteracao1,setDalteracao1] = useState(new Date);
             
         
              const [usaDcadastro1,setUsaDcadastro1] = useState(false);
              const [usaDAlteracao1,setusaDalteracao1] = useState(false);
             
         
              const [dCadastro2,setDcadastro2] = useState(new Date);
              const [dAlteracao2,setDalteracao2] = useState(new Date);
             
         
              const [usaDcadastro2,setUsaDcadastro2] = useState(false);
              const [usaDAlteracao2,setusaDalteracao2] = useState(false);
             
    

    function handlePageChange(value){
      if(value === "&laquo;" || value === '... '){
        setnPag(1);
      }else if (value === "&lsaquo;" ){
        if (nPag !== 1){
          setnPag(Number(nPag)-1);
        }
      }else if(value === "&rsaquo;"){
        setnPag(Number(nPag)+1);        
      }else if(value === "&raquo;" || value === ' ...' ){
        setnPag(totalPaginas);        
      }else{
        setnPag(value);
      }    
     
     }

     let config = {
      headers: {
        'Authorization': localStorage.getItem("token")
      }
    }

    let config2 = {
      headers: {
        'Authorization': localStorage.getItem("token2")
      }
    }

    function handleDalteracaocheck(e){
      setusaDalteracao1(e.target.checked);
      setusaDalteracao2(e.target.checked);
    }
        
    function handleDcadastrocheck(e){
      setUsaDcadastro1(e.target.checked);
      setUsaDcadastro2(e.target.checked);
    }
  
    console.log(codDelete);
    
    function confirmDeleteUser(){
      api.post(vhostV1('webcash/compras/cancelar/nota/'+codDelete),{},config)
      .then(function(response){
         console.log(response);
         
        setConfirmaDelete(false);
        window.location.reload();
      }).catch(function(error){
        console.log(error);
        
      })
    }

    function setDeleteUser(cod){
      setConfirmaDelete(true);
      setCodDelete(cod);
    }

    function setExcluirCompra(cod){
      setCodDelete(cod);
      setConfirmaExcluir(true);
    }
   

     useEffect(function(){
      setLoad(true)

      const sJson = {}

      if(usaDcadastro1 === true)
        { sJson.data_cadastro1=dCadastro1}
        if(usaDAlteracao1 === true)
        { sJson.data_emissao1=dAlteracao1}
        if(usaDcadastro2 === true)
        { sJson.data_cadastro2=dCadastro2}
        if(usaDAlteracao2 === true)
        { sJson.data_emissao2=dAlteracao2}
        
     
      sJson.pagina=nPag;
      sJson.regPag=10;
      sJson.busca='';
      sJson.status='';
      console.log(sJson);
      

      api.post(vhostV1('webcash/compras'),sJson,config)
      .then(function(response){
        console.log(response.data);
        setPedidos(response.data.dados);
        setTotalPaginas(response.data.quantidadeDePaginas);
        setSresult(response.data.result);
        setLoad(false);
      })
      .catch(function(error){
        console.log(error);
        setLoad(false);
      })
    


     },[nPag])

          // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);

     function filtraCompra(){
      setLoad(true);

      const sJson = {}

      if(usaDcadastro1 === true)
        { sJson.data_cadastro1=dCadastro1}
        if(usaDAlteracao1 === true)
        { sJson.data_emissao1=dAlteracao1}
        if(usaDcadastro2 === true)
        { sJson.data_cadastro2=dCadastro2}
        if(usaDAlteracao2 === true)
        { sJson.data_emissao2=dAlteracao2}
        
     
      sJson.pagina=nPag;
      sJson.regPag=10;
      sJson.busca='';
      sJson.status='';
      console.log(sJson);
      

      api.post(vhostV1('webcash/compras'),sJson,config)
      .then(function(response){
        console.log(response.data);
        setPedidos(response.data.dados);
        setTotalPaginas(response.data.quantidadeDePaginas);
        setSresult(response.data.result);
        setLoad(false);
      })
      .catch(function(error){
        console.log(error);
        setLoad(false);
      })


     }

     function limparFiltros(){
      setLoad(true);
      setTipoRelatorio(0);
      setTipo('TODOS');
      setDcadastro1(new Date);
      setDalteracao1(new Date);
      setDcadastro2(new Date);
      setDalteracao2(new Date);
      setUsaDcadastro1(false);
      setusaDalteracao1(false);
      setUsaDcadastro2(false);
      setusaDalteracao2(false);

      const sJson = {}

      sJson.pagina=1;
      sJson.regPag=10;
      sJson.busca='';
      sJson.status='';
      console.log(sJson);
      

      api.post(vhostV1('webcash/compras'),sJson,config)
      .then(function(response){
        console.log(response.data);
        setPedidos(response.data.dados);
        setTotalPaginas(response.data.quantidadeDePaginas);
        setSresult(response.data.result);
        setLoad(false);
      })
      .catch(function(error){
        console.log(error);
        setLoad(false);
      })
     }


     function deletarCompra(){
      api.delete(vhostV1('webcash/compras/deletar/nota/'+codDelete),config)
                .then(function(response){
                  console.log(response);
                  setConfirmaDelete(false);
                  window.location.reload();
                  
                }).catch(function (error){
                  console.log(error);
                  
                })
     }

     function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      
      return `${day}/${month}/${year}`;
    }




  return<div>

  <Navbar/>
  <div className="container-fluid titulo offset-lg-1 col-lg-10">

  <div className="d-flex justify-content-between"> 
  <h2 className="d-inline" >Compras</h2>
  
     
          <div>
          
          <Link type="button"  className="btn btn-primary btn-cli"  to="/app/estoque/novacompra/0/-1"><i className="bi bi-plus-circle-fill"></i> Incluir</Link>
          <button type="button" className="btn btn-secondary btn-cli" data-bs-toggle="modal" data-bs-target="#moda-filtro"><i className="bi bi-funnel-fill"></i>Filtros</button>
          {/*<button type="button" className="btn btn-danger btn-cli"  data-bs-toggle="modal" data-bs-target="#staticBackdrop"><i className="bi bi-printer-fill"></i> Relatório</button>
          <SalesReport/>*/}
          </div>

          
          
      </div> 
   
  <hr/>
  

  <div className="row">
          <WidgetCompra/>
  </div>

  
  <div className="modal fade" id="moda-filtro" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">Filtros</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="contnt-modal">
                    <div className="row">
                      
                    
                    </div>      
                                        

                   <div className="row">
                    <div>
                     <h5>Tipo  </h5>   
                     <div>
                     <div className="form-control d-inline me-3">
                        <select name="status" id="status" onChange={(e)=> setTipo(e.target.value)}>
                            <option value="TODOS">Todos</option>
                            <option value="RECIBO">Autorizado</option>
                            <option value="CANCELADO">Cancelado</option>
                        </select>
                    </div>
                    
                   </div>
                   </div>

                   
                          
                     </div>
                     <br />

                     <div className="row">
                    
                    </div>


                    <div className="row">
                    <div className="datas col-6">
                        <h6>Datas Iniciais</h6>
                          <div className="form-check form-switch ml-2" >
                            <input className="form-check-input" onChange={(e) => handleDcadastrocheck(e)} checked={usaDcadastro1} type="checkbox" role="switch"  id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Cadastro</label>
                            <input type="date" value={dCadastro1} onChange={(e) => setDcadastro1(e.target.value)} className='form-control' />
                          </div>

                          <div className="form-check form-switch ml-2" >
                            <input className="form-check-input" type="checkbox" onChange={(e) => handleDalteracaocheck(e)} checked={usaDAlteracao1} role="switch" id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Emissão</label>
                            <input type="date" value={dAlteracao1} onChange={(e) => setDalteracao1(e.target.value)} className='form-control'/>
                          </div>

                          
                     </div>

                     <div className="datas col-6">
                        <h6 id='data-final-filtro'>Datas Finais</h6>
                          <div className="form-check form-switch mt-4" >
                           
                            <input type="date" value={dCadastro2} onChange={(e) => setDcadastro2(e.target.value)} className='form-control' />
                          </div>

                          <div className="form-check form-switch mt-4" >
                            <input type="date" value={dAlteracao2} onChange={(e) => setDalteracao2(e.target.value)} className='form-control'/>
                          </div>

                         
                     </div>
                     </div>

                  </div>
                </div>
                <div className="modal-footer d-flex">
                                   
                  
                  <div>
                    {/* <button type="button"  className="btn btn-success btn-cli" data-bs-dismiss="modal">Imprimir</button>                    */}
                    <button type="button" onClick={limparFiltros} className="btn btn-danger btn-cli" data-bs-dismiss="modal">Limpar Filtros</button>
                    <button type="button" onClick={filtraCompra} className="btn btn-secondary btn-cli" data-bs-dismiss="modal">Ativar</button>
                  </div>
                             

                  

                </div>
              </div>
            </div>
          </div>


 { load === true?<Loading/>:null}   
 { sResult === 1?
  <table id='form-label'  className="table table-hover table-striped">
      <thead>
      <tr>
          <th scope="col">PEDIDO</th>
          <th scope="col">CLIENTE</th>
          <th scope="col">Nº NOTA</th>
          <th scope="col">DATA</th>
          <th scope="col">CANCELADO</th>
          <th scope='col'>LANÇADO</th>
          <th scope="col">VALOR</th>
          <th scope="col">AÇÃO</th>
          </tr>
      </thead>
      <tbody className="table-group-divider">
        
      {
      pedidos.map((pedido) => {
          return <tr key={pedido.COD_COMPRA}>
                 <td>{("0000" + pedido.COD_COMPRA).slice(-6)}</td>
                 <td>{pedido.RAZAO}</td>
                 <td>{pedido.DOCUMENTO}</td>
                 <td>{formatDate(pedido.DATA)}</td>
                 <td>{pedido.CANCELADO}</td>
                 <td>{pedido.SITLANC}</td>
                 <td> R$ {Number(pedido.VALOR_TOTAL_NOTA).toFixed(2)}</td>
                
                 
                 
                 

                 <td>
                   <div className="dropdown" >
                      <button className="btn btn-outline-secondary dropdown-toggle" id='botao-opcoes' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Opções
                      </button>
                      <ul className="dropdown-menu">
                      {pedido.SITLANC === "NÃO"?
                        <>
                        <li><a href={`/app/estoque/novaCompra/${pedido.COD_COMPRA}/2`}  value={pedido.COD_COMPRA} className="dropdown-item"><i className="bi bi-pen-fill"></i>Editar</a></li>
                        {/* <li><button onClick={(e) => setExcluirCompra(e.target.value)} value={pedido.COD_COMPRA} className="dropdown-item"><i className="bi bi-trash-fill"></i>Excluir</button></li> */}
                        </>:
                        <>
                        {/* <li><a href={`/app/estoque/novaCompra/${pedido.COD_COMPRA}/2`}  value={pedido.COD_COMPRA} className="dropdown-item"><i className="bi bi-pen-fill"></i>Editar</a></li> */}
                          {pedido.responsavel === "0"?null:<li><button onClick={(e) => setDeleteUser(e.target.value)} value={pedido.COD_COMPRA} className="dropdown-item"><i className="bi bi-x-circle-fill"></i>Cancelar</button></li>}
                          </>}
                        
                          <li><a href={`/app/estoque/novaCompra/${pedido.COD_COMPRA}/0`} className="dropdown-item"><i className="bi bi-search"></i>Visualizar</a></li>

                      </ul>
                   </div>
                </td>
                 

                 </tr>
        } )}  
      </tbody>
    </table>          
    :<BuscaVazaia/>} 


            <div className="row mt-5 mb-5">
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>
 

   {
     confirmaEmissao ? 
     <SweetAlert
        success                         
        confirmBtnText="OK"
        confirmBtnBsStyle="success"
        title="Parabéns"
        onConfirm={() => setConfirmaEmissao(false)}                            
      >
        Nota Emitida com sucesso!
      </SweetAlert>:null
     
    }

    {
     erroEmissao ? 
     <SweetAlert
        danger
        confirmBtnText="OK"
        confirmBtnBsStyle="danger"
        title="Erro"
        onConfirm={() => setErroEmissao(false)}                            
      >
        {msgErro}
      </SweetAlert>:null
     
    }

{
     confirmaDelete ? 
     <SweetAlert
     warning
     showCancel
     showCloseButton
     confirmBtnText="Sim"
     confirmBtnBsStyle="danger"
     cancelBtnText="Não"
     cancelBtnBsStyle='ligth'
     title="Atenção"
     onConfirm={() => confirmDeleteUser(codDelete)}
     onCancel={() => setConfirmaDelete(false)}
     focusCancelBtn
     reverseButtons                          
      >
       Deseja Cancelar essa Nota?
      </SweetAlert>:null
     
    }

{
     confirmaExcluir ? 
     <SweetAlert
     warning
     showCancel
     showCloseButton
     confirmBtnText="Sim"
     confirmBtnBsStyle="danger"
     cancelBtnText="Não"
     cancelBtnBsStyle='ligth'
     title="Atenção"
     onConfirm={() => deletarCompra(codDelete)}
     onCancel={() => setConfirmaExcluir(false)}
     focusCancelBtn
     reverseButtons                          
      >
       Deseja Excluir essa Nota?
      </SweetAlert>:null
     
    }

  

</div>   
<FooterBar/>   
</div>
  
}

export default Compra
